/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Adjustment_WarningInputs */

const vi_einvoice_adjustment_warning = /** @type {(inputs: Einvoice_Adjustment_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đây là hóa đơn điều chỉnh.`)
};

/**

* @param {Einvoice_Adjustment_WarningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_adjustment_warning = /** @type {((inputs?: Einvoice_Adjustment_WarningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Adjustment_WarningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_adjustment_warning(inputs)
});